


























































































































































































































































































































































































































































































































































































































































































































































































// @ts-ignore
import v8n from 'v8n';
import moment from 'moment';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import {
  ApiError,
  Booking,
  VehicleType,
  Airline,
  Flight,
  Extra,
  Lot,
  LotRegion,
  Customer,
  Vehicle,
  ExtraVariation,
  Quote,
  Discount,
  BookingQuote,
  User,
  BookingLog,
} from '@/api';
import { apiBase, apiNamespace } from '@/config';
import { snackModule, authModule, bookingModule } from '@/store';
import { Route } from 'vue-router';
import AbstractTable from '@/components/admin/AbstractTable.vue';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import BookingPayment from '@/components/admin/BookingPayment.vue';
import CurrencyField from '@/components/CurrencyField.vue';
import DatePicker from '@/components/DatePicker.vue';
import TimePicker from '@/components/TimePicker.vue';
import RelAutocomplete from '@/components/RelAutocomplete.vue';
import RelAutocompleteAsync from '@/components/RelAutocompleteAsync.vue';
import BookingExtras from '@/components/admin/BookingExtras.vue';
import RelSelect from '@/components/RelSelect.vue';

@Component({
  components: {
    AbstractTable,
    ConfirmDialog,
    BookingPayment,
    CurrencyField,
    DatePicker,
    TimePicker,
    RelAutocomplete,
    RelAutocompleteAsync,
    BookingExtras,
    RelSelect,
  },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  loading: boolean = false;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  startDateShow: boolean = false;
  endDateShow: boolean = false;

  startDate = '';
  startTime = '';
  endTime = '';
  ignoreDatetimeChange = false;

  flightNumberOut: Flight | null = null;
  flightNumberIn: Flight | null = null;

  get formattedStartDate() {
    if (!this.startDate) {
      return '';
    }
    return moment(this.startDate, 'YYYY-MM-DD').format('D/M/YYYY');
  }

  get endDate() {
    if (this.booking?.endDatetime) {
      return moment(this.booking.endDatetime).format('YYYY-MM-DD');
    } else {
      return '';
    }
  }
  set endDate(val) {
    if (!this.booking) {
      return;
    }
    if (val) {
      const endTime = this.endTime || '23:59';
      this.booking.endDatetime = moment(
        `${val} ${endTime}`,
        'YYYY-MM-DD HH:mm',
      ).toISOString();
    } else {
      this.booking.endDatetime = null;
    }
  }

  get formattedEndDate() {
    if (!this.endDate) {
      return '';
    }
    return moment(this.endDate, 'YYYY-MM-DD').format('D/M/YYYY');
  }
  set formattedEndDate(val: string) {
    this.endDate = val;
  }

  get makes() {
    const defaultMakes = bookingModule.makes;
    defaultMakes.push('Other');
    return defaultMakes;
  }
  get colours() {
    const defaultColours = bookingModule.colours;
    defaultColours.push('Other');
    return defaultColours;
  }

  bookingExtras: Extra[] = [];

  booking: Booking | null = null;

  customer: Customer | null = null;
  bookingVehicle: Vehicle | null = null;

  quotes: Quote[] = [];
  extraVariations: ExtraVariation[] = [];

  bookingLogs: BookingLog[] = [];

  makePayment: boolean = false;
  hasPaid: boolean = false;

  bookingTypes: string[] = [
    'New',
    'Regular',
    'New - Website',
    'Regular - Website',
    'Staff',
    'Senoirs',
    'RACT',
    'Qantas Staff',
    'Pensioner',
    'Long term',
    'Email',
    "Andrew's Parking",
    'Adrian',
  ];

  statusItems: Array<{ text: string; value: string }> = [
    { text: 'Pending', value: 'pending' },
    { text: 'Complete', value: 'complete' },
    { text: 'Cancelled', value: 'cancelled' },
    { text: 'Abandoned', value: 'abandoned' },
    { text: 'Error', value: 'error' },
    { text: 'Payment failed', value: 'payment_failed' },
  ];

  paymentMethodItems: Array<{ text: string; value: string }> = [
    { text: 'Stripe', value: 'stripe' },
    { text: 'Cash', value: 'cash' },
    { text: 'Eftpos', value: 'eftpos' },
    { text: 'Visa', value: 'visa' },
    { text: 'Mastercard', value: 'mastercard' },
    { text: 'Cheque', value: 'cheque' },
    { text: 'Account', value: 'account' },
    { text: 'por', value: 'Payment on return' },
  ];

  paymentStatusItems: Array<{ text: string; value: string }> = [
    { text: 'Unpaid', value: 'unpaid' },
    { text: 'Paid', value: 'paid' },
    { text: 'Refunded', value: 'refunded' },
  ];

  makeSelect: string = '';
  colourSelect: string = '';

  nextFn: (() => void) | null = null;
  leaveConfirmDialog: boolean = false;
  confirmLeaveContent: string =
    'Are you sure you would like to leave? Any unsaved changes will be lost.';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  requiredNumber = [
    (v: string) =>
      v8n()
        .number()
        .greaterThanOrEqual(0)
        .test(v) || 'Must be a number greater than or equal to 0',
  ];

  validNumber = [
    (v: number) =>
      v8n()
        .optional(
          v8n()
            .number()
            .greaterThan(0),
          true,
        )
        .test(v) || 'Number must be greater than 0',
  ];

  requiredRate = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'Must be a number between 0 and 100',
    (v: string) =>
      v8n()
        .number()
        .not.empty()
        .between(0, 100)
        .test(Number(v)) || 'Must be a number between 0 and 100',
  ];

  requiredObject = [
    (v: Airline | VehicleType | Lot) => {
      if (!v) {
        return 'This field is required';
      }

      return (
        v8n()
          .string()
          .not.empty()
          .test(v.id) || 'This field is required'
      );
    },
  ];

  get invoiceUrl() {
    return apiBase + apiNamespace + '/bookings/' + this.bookingId + '/invoice/';
  }

  get isAdmin() {
    return authModule.isAdmin;
  }

  get titles() {
    if (!bookingModule.titles) {
      return;
    }
    return bookingModule.titles;
  }

  get windowSize() {
    return window.outerWidth;
  }

  get newBooking() {
    return !this.bookingId;
  }

  get regionRowOptions() {
    if (!this.booking || !this.booking.lotRegion) {
      return;
    }
    const rowsNumber = this.booking.lotRegion.rows;
    const rows = [];

    for (let index = 0; index < rowsNumber; index++) {
      const value = 'Row ' + (index + 1);
      rows.push({
        text: value,
        value: index + 1,
      });
    }
    return rows;
  }

  get vehicleType() {
    if (!this.booking) {
      return;
    }
    return this.newBooking
      ? this.booking.vehicle.vehicleType
      : this.booking.vehicleType;
  }

  get discountRate() {
    if (!this.booking) {
      return '0';
    }
    return String(parseFloat(this.booking.discountRate) * 100);
  }
  set discountRate(val) {
    if (!this.booking) {
      return;
    }
    const rateVal = parseFloat(val);
    if (rateVal > 0) {
      this.booking.discountRate = String(rateVal / 100);
    } else {
      this.booking.discountRate = '0';
    }
  }

  get bookingId() {
    return this.$route.params.bookingId;
  }

  customerScopeFactory() {
    return Customer.includes([]);
  }

  staffScopeFactory() {
    return User.includes(['customer']);
  }

  get staffWhere() {
    return { staff: true };
  }

  vehicleScopeFactory() {
    return Vehicle.includes([]);
  }

  get vehicleWhere() {
    if (!this.booking || !this.booking.customer) {
      return;
    }
    return {
      owner: this.booking.customer.id,
      regoUuid: false,
    };
  }

  vehicleTypeScopeFactory() {
    return VehicleType.includes([]).order({ name: 'asc' });
  }

  airlineScopeFactory() {
    return Airline.includes([]);
  }

  flightOutScopeFactory() {
    return Flight.where({ departure: true })
      .order({ time: 'asc' })
      .includes(['busTrip']);
  }
  flightInScopeFactory() {
    return Flight.where({ departure: false }).order({ time: 'asc' });
  }

  get flightOutWhere() {
    if (!this.booking || !this.booking.airlineOut) {
      return;
    }
    return { airline: this.booking.airlineOut.id, service: this.service };
  }
  get flightInWhere() {
    if (!this.booking || !this.booking.airlineIn) {
      return;
    }
    return { airline: this.booking.airlineIn.id, service: this.service };
  }

  get service() {
    if (!this.startDate) {
      return;
    }

    const day = moment(this.startDate, 'YYYY-MM-DD').weekday();
    if (day === 0 || day === 6) {
      return 'weekend';
    } else {
      return 'weekday';
    }
  }

  get notFlyingOut() {
    if (!this.booking || !this.booking.airlineOut) {
      return false;
    }
    return this.booking.airlineOut.name === 'Not flying';
  }

  get notFlyingIn() {
    if (!this.booking || !this.booking.airlineIn) {
      return false;
    }
    return this.booking.airlineIn.name === 'Not flying';
  }

  lotScopeFactory() {
    return Lot.includes([]);
  }

  lotRegionScopeFactory() {
    return LotRegion.includes([]);
  }

  get lotRegionWhere() {
    if (!this.booking || !this.booking.lot) {
      return;
    }
    return { lot: this.booking.lot.id };
  }

  discountScopeFactory() {
    return Discount.includes([]);
  }

  back() {
    this.$router.back();
  }

  beforeRouteLeave(to: Route, from: Route, next: (args?: any) => void) {
    if (this.booking && this.booking.isDirty()) {
      this.nextFn = next;
      this.leaveConfirmDialog = true;
      next(false);
    } else {
      next();
    }
  }

  leave() {
    if (this.nextFn) {
      this.nextFn();
    }
  }

  checkIn() {
    if (!this.bookingId) {
      return;
    }
    this.$router.push({
      name: 'admin-bookings-checkin',
      params: { bookingId: this.bookingId },
    });
  }

  paymentSuccess() {
    if (!this.booking) {
      return;
    }
    this.makePayment = false;
    this.hasPaid = true;
    (this.$refs.amountPaid as CurrencyField).setValue(this.booking.totalCost);
    this.booking.paymentMethod = 'stripe';
    this.booking.paymentStatus = 'paid';
    this.booking.paymentDatetime = new Date().toISOString();
  }

  setExtrasCost() {
    if (!this.booking || !this.booking.extras) {
      return;
    }
    const extrasCost = Object.values(this.booking.extrasPrices).reduce(
      (a, b) => a + (Number(b) || 0),
      0,
    );
    (this.$refs.extrasCost as CurrencyField).setValue(String(extrasCost));
  }

  generateErrors(e: ApiError) {
    const friendlyPointer = e.source.pointer.split('/').pop();
    return snackModule.showSnackbar(`${e.detail}: ${friendlyPointer}`);
  }

  clearFlightOut() {
    if (!this.booking) {
      return;
    }
    this.flightNumberOut = null;
    this.startTime = '';
    this.booking.busDepartureTime = null;
  }

  clearFlightIn() {
    this.flightNumberIn = null;
    this.endTime = '';
  }

  async calculateCosts() {
    if (
      !this.startDate ||
      !this.endDate ||
      !this.booking ||
      !this.booking.discountRate ||
      !this.booking.lot
    ) {
      return;
    }

    try {
      const quote = new BookingQuote();
      const startDateTime = this.booking.startDatetime
        ? this.booking.startDatetime
        : moment(`${this.startDate}`, 'YYYY-MM-DD HH:mm').toISOString();

      const endDateTime = this.booking.endDatetime
        ? this.booking.endDatetime
        : moment(`${this.endDate}`, 'YYYY-MM-DD HH:mm').toISOString();

      quote.startDatetime = startDateTime;
      quote.discountRate = this.booking.discountRate;
      quote.lot = this.booking.lot;

      if (moment(startDateTime).isAfter(moment())) {
        quote.calculateSubscriptionGaps = false;
      } else {
        quote.calculateSubscriptionGaps = true;
      }

      if (this.booking.extrasCost) {
        quote.extrasCost = this.booking.extrasCost;
      }

      if (endDateTime) {
        quote.endDatetime = endDateTime;
      }

      if (this.booking.customer && this.booking.customer.id) {
        quote.customer = this.booking.customer;
      }

      await quote.save({ with: ['lot.id', 'customer.id'] });

      (this.$refs.amountDiscounted as CurrencyField).setValue(
        String(quote.amountDiscounted),
      );
      (this.$refs.subscriptionDiscount as CurrencyField).setValue(
        String(quote.subscriptionDiscount),
      );
      (this.$refs.totalCost as CurrencyField).setValue(String(quote.totalCost));
      (this.$refs.parkingCost as CurrencyField).setValue(
        String(quote.parkingCost),
      );
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async getQuotes() {
    if (
      !this.booking ||
      !this.booking.startDatetime ||
      !this.booking.endDatetime
    ) {
      return;
    }
    try {
      this.quotes = (
        await Quote.extraParams({
          start_date: moment(this.booking.startDatetime).format('YYYY-MM-DD'),
          end_date: moment(this.booking.endDatetime).format('YYYY-MM-DD'),
        })
          .where({
            lot_slug__in: ['indoor', 'outdoor'],
          })
          .includes(['lot'])
          .all()
      ).data;
    } catch (err) {
      // Error
      snackModule.showSnackbar('Quotes not found');
    }
  }

  async getExtraVariations() {
    if (!this.booking || !this.vehicleType) {
      return;
    }
    try {
      this.extraVariations = (
        await ExtraVariation.where({
          vehicleType: this.vehicleType.id,
        }).all()
      ).data;
    } catch (err) {
      // Error
      snackModule.showSnackbar('Extras Variations not found');
    }
  }

  async getHistory() {
    if (!this.booking || !authModule.isAdmin) {
      return;
    }
    try {
      this.bookingLogs = (
        await BookingLog.where({
          booking: this.booking.id,
        })
          .includes(['user.customer'])
          .order({ timestamp: 'desc' })
          .per(5)
          .all()
      ).data;
    } catch (err) {
      // Error
      snackModule.showSnackbar('Booking logs not found');
    }
  }

  generateRandomEmail() {
    if (!this.booking) {
      return;
    }
    const email = `no-email-${this.uuidv4()}@hobartairparking.com.au`;
    if (this.newBooking) {
      this.booking.customer.email = email;
    } else {
      this.booking.email = email;
    }
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      /* tslint:disable:no-bitwise */
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      /* tslint:enable:no-bitwise */
      return v.toString(16);
    });
  }

  async save() {
    if (!this.booking) {
      return;
    }

    if (
      !(this.$refs.bookingForm as Vue & { validate: () => boolean }).validate()
    ) {
      snackModule.showSnackbar('Please fill-out all required fields');
      return;
    }

    if (this.flightNumberOut && this.flightNumberOut.id !== '0') {
      this.booking.flightNumberOut = this.flightNumberOut.flightNumber;
    }
    if (this.flightNumberIn && this.flightNumberIn.id !== '0') {
      this.booking.flightNumberIn = this.flightNumberIn.flightNumber;
    }

    if (this.newBooking) {
      if (this.makeSelect && this.makeSelect !== 'Other') {
        this.booking.vehicle.make = this.makeSelect;
      }
      if (this.colourSelect && this.colourSelect !== 'Other') {
        this.booking.vehicle.colour = this.colourSelect;
      }
    } else {
      if (this.makeSelect && this.makeSelect !== 'Other') {
        this.booking.make = this.makeSelect;
      }
      if (this.colourSelect && this.colourSelect !== 'Other') {
        this.booking.colour = this.colourSelect;
      }
    }

    // Spraypaint doesn't like empty arrays in relationships
    // so we utilise isMarkedForDisassociation as a hacky solution
    if (this.booking.extras && this.bookingExtras.length === 0) {
      this.booking.extras.map(extra => {
        extra.isMarkedForDisassociation = true;
      });
    } else {
      this.booking.extras = this.bookingExtras;
    }

    try {
      this.loading = true;
      if (this.booking.customer) {
        await this.booking.customer.save();
      }

      if (this.$route.name === 'admin-bookings-add' && this.booking.customer) {
        this.booking.vehicle.owner = this.booking.customer;
        await this.booking.vehicle.save({
          with: ['vehicleType.id', 'owner.id'],
        });
      }

      await this.booking.save({
        with: [
          'vehicleType.id',
          'airlineOut.id',
          'airlineIn.id',
          'lot.id',
          'lotRegion.id',
          'customer.id',
          'vehicle.id',
          'extras.id',
          'createdBy.id',
          'discount.id',
          'parkedBy.id',
        ],
      });
      this.booking.reset();
      if (
        this.$route.name === 'admin-bookings-add' &&
        this.booking &&
        this.booking.id
      ) {
        this.$router.push({
          name: 'admin-bookings-edit',
          params: { bookingId: this.booking.id },
        });
        snackModule.showSnackbar('Booking Created');
      } else {
        snackModule.showSnackbar('Booking Updated');
      }
      this.$router.push({ name: 'admin-bookings' });
    } catch (err) {
      err.response.errors.forEach((e: ApiError) => this.generateErrors(e));
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    if (this.$route.name === 'admin-bookings-edit' && this.bookingId) {
      try {
        this.booking = (await Booking.find(this.bookingId)).data;

        if (this.booking.customer.id) {
          this.booking.customer = (
            await Customer.find(this.booking.customer.id)
          ).data;
        }

        if (this.makes.includes(this.booking.make)) {
          this.makeSelect = this.booking.make;
        } else {
          this.makeSelect = 'Other';
        }

        if (this.colours.includes(this.booking.colour)) {
          this.colourSelect = this.booking.colour;
        } else {
          this.colourSelect = 'Other';
        }

        await this.getExtraVariations();
        await this.getQuotes();
        await this.getHistory();
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Booking not found');
      }

      // Let's populate some things from the exiting booking
      if (this.booking) {
        // Set startDate if one already attached to this.booking
        if (this.booking.startDatetime) {
          this.startDate = moment(this.booking.startDatetime).format(
            'YYYY-MM-DD',
          );
          this.startTime = moment(this.booking.startDatetime).format('HH:mm');
        }

        // Set endTime and endDate if one already attached to this.booking
        if (this.booking.endDatetime) {
          this.endTime = moment(this.booking.endDatetime).format('HH:mm');
          this.endDate = moment(this.booking.endDatetime).format('YYYY-MM-DD');
        }
      }
    } else {
      const preselectCustomerId = this.$route.query.customer;
      let bookingCustomer = new Customer();

      if (
        typeof preselectCustomerId === 'string' &&
        preselectCustomerId.length
      ) {
        try {
          bookingCustomer = (await Customer.find(preselectCustomerId)).data;
        } catch (err) {
          // most likely this means not found
          snackModule.showSnackbar('Customer not found');
        }
      }

      const bookingObj = {
        customer: bookingCustomer,
        vehicle: new Vehicle(),
        extrasPrices: {},
        status: 'complete',
      };
      this.booking = new Booking(bookingObj);
      this.booking.email = bookingCustomer.email;
    }
  }

  @Watch('customer')
  selectedCustomerChanged() {
    if (this.$route.name === 'admin-bookings-edit' || !this.booking) {
      return;
    }

    if (this.customer) {
      this.booking.customer = this.customer;
      this.booking.bookingType = 'Regular';
      this.booking.email = this.customer.email;
    } else {
      this.booking.customer = new Customer();
      this.booking.bookingType = 'New';
    }
  }

  @Watch('bookingVehicle')
  vehicleChanged() {
    if (
      this.$route.name === 'admin-bookings-edit' ||
      !this.booking ||
      !this.booking.customer
    ) {
      return;
    }

    if (this.bookingVehicle) {
      this.booking.vehicle = this.bookingVehicle;

      if (this.makes.includes(this.booking.vehicle.make)) {
        this.makeSelect = this.booking.vehicle.make;
      } else if (this.booking.vehicle.make) {
        this.makeSelect = 'Other';
      } else {
        this.makeSelect = '';
      }

      if (this.colours.includes(this.booking.vehicle.colour)) {
        this.colourSelect = this.booking.vehicle.colour;
      } else if (this.booking.vehicle.colour) {
        this.colourSelect = 'Other';
      } else {
        this.colourSelect = '';
      }
    } else {
      this.booking.vehicle = new Vehicle();
      this.makeSelect = '';
      this.colourSelect = '';
    }
  }

  @Watch('booking.customer')
  customerChanged() {
    if (
      this.$route.name === 'admin-bookings-edit' ||
      !this.booking ||
      !this.booking.customer
    ) {
      return;
    }

    this.booking.vehicle = new Vehicle();
    this.calculateCosts();
  }

  get lotId() {
    if (!this.booking) {
      return false;
    }
    return this.booking.lot ? this.booking.lot.id : null;
  }

  @Watch('lotId')
  lotChanged(val: Lot | boolean, oldVal: Lot | boolean) {
    if (oldVal === false) {
      return;
    }
    this.calculateCosts();
  }

  @Watch('booking.vehicle.vehicleType')
  @Watch('booking.vehicleType')
  async vehicleTypeChanged(val: VehicleType, oldVal: VehicleType) {
    if (
      !val ||
      (this.bookingId && !oldVal) ||
      (oldVal && val.id === oldVal.id)
    ) {
      return;
    }
    try {
      await this.getExtraVariations();
      (this.$refs.extras as BookingExtras).updateAllCosts();
    } catch (err) {
      // Error
    }
  }

  @Watch('booking.extras')
  extrasChanged() {
    if (!this.booking) {
      return;
    }
    this.bookingExtras = this.booking.extras;
  }

  @Watch('booking.extrasPrices', { deep: true })
  extraPricessChanged(
    val: { [id: string]: string },
    oldVal: { [id: string]: string },
  ) {
    if (typeof oldVal === 'undefined') {
      return;
    }
    this.setExtrasCost();
  }

  get discountId() {
    if (!this.booking) {
      return false;
    }
    return this.booking.discount ? this.booking.discount.id : null;
  }

  @Watch('discountId')
  discountChanged(val: string, oldVal: string | boolean) {
    if (oldVal === false || !this.booking) {
      return;
    }
    if (val) {
      this.booking.discountRate = this.booking.discount.rate;
      this.booking.promoCode = this.booking.discount.promoCode;
    } else {
      this.booking.discountRate = '0';
      this.booking.promoCode = '';
    }
  }

  @Watch('startDate')
  @Watch('startTime')
  startDateTimeChange(val: string) {
    if (!this.booking) {
      return;
    }

    const currentDate = moment(this.booking.startDatetime).format('YYYY-MM-DD');
    const currentTime = moment(this.booking.startDatetime).format('HH:mm');
    if (this.startTime && val !== currentDate && val !== currentTime) {
      this.booking.startDatetime = moment(
        `${this.startDate} ${this.startTime}`,
        'YYYY-MM-DD HH:mm',
      ).toISOString();
    }
  }

  @Watch('endTime')
  endDateTimeChange(val: string) {
    if (!this.booking) {
      return;
    }

    const currentDate = moment(this.booking.endDatetime).format('YYYY-MM-DD');
    const currentTime = moment(this.booking.endDatetime).format('HH:mm');
    if (this.endTime && val !== currentDate && val !== currentTime) {
      this.booking.endDatetime = moment(
        `${this.endDate} ${this.endTime}`,
        'YYYY-MM-DD HH:mm',
      ).toISOString();
    }
  }

  @Watch('startDate')
  startDateChange(val: string, oldVal: string) {
    if (
      this.booking &&
      (this.newBooking || (!this.newBooking && oldVal !== ''))
    ) {
      this.endDate = this.startDate;
    }
  }

  @Watch('flightNumberOut')
  flightNumberOutChange(val: Flight, oldVal: Flight) {
    if (
      this.booking &&
      (this.newBooking || (!this.newBooking && oldVal !== null)) &&
      val &&
      val.id !== '0'
    ) {
      this.startTime = val.time;
      this.booking.busDepartureTime = val.busTrip
        ? val.busTrip.departureTime
        : '';
    }
  }

  @Watch('flightNumberIn')
  flightNumberInChange(val: Flight, oldVal: Flight) {
    if (
      (this.newBooking || (!this.newBooking && oldVal !== null)) &&
      val &&
      val.id !== '0'
    ) {
      this.endTime = val.time;
    }
  }

  @Watch('booking.passengersOut')
  passengersChange(val: number) {
    if (this.booking && val) {
      this.booking.passengersIn = val;
    }
  }

  @Watch('endDate')
  endDateChanged(val: string, oldVal: string) {
    if (
      !this.booking ||
      !val ||
      (!this.newBooking && !this.booking.isDirty() && oldVal === '')
    ) {
      return;
    }
    this.calculateCosts();
  }

  @Watch('booking.extrasCost')
  @Watch('booking.discountRate')
  costsChanged(val: string, oldVal: string) {
    if (
      !this.booking ||
      !val ||
      (!this.newBooking && typeof oldVal === 'undefined') ||
      Number(val).toFixed(2) === Number(oldVal).toFixed(2)
    ) {
      return;
    }
    this.calculateCosts();
  }
}
